// 审批管理
export default {
    autoApprovalSettings: '自动审批设置',
    taskNumber: '任务编号',
    approvalTime: '审批时间',
    approver: '审批人',
    reasonFailure: '未通过原因',
    mapView: '地图查看',
    pass: '通过',
    fail: '不通过',
    tip_pleaseEnterFail: '请输入未通过原因',
    tip_surePass: '是否确定通过？',
    warning1: '自动审批功能需要在设置后生效。',
    warning2: '自动审批开启后，自动审批列表中的用户提交的审批将自动通过，但系统仍会记录该任务。',
    department: '部门',
    username: '用户名',
    phoneNumber: '手机号',
    userManagement: '用户管理',
    role: '角色',
    remove: '移除',
    bulkRemoval: '批量移除',
    tip_remove: '是否确定移除？',
    autoApproval: '自动审批',
    userNotAdded: '未添加用户',
    userAdded: '已添加用户',
    pleaseEnterUserName: '请输入用户名',
    viewTasks: '查看任务',
    autoApprovalPeriod: '自动审批时段',
    approvalTaskType: '审批任务类型',
    enterAutoApproval: '请输入自动审批时段',
}